import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'


export const initialState = {
    task: null,
    fetching: false,
    error: null,
    noFollowUp: false,
    processFlowVisible: false,
    validationMessageList: [],
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...state,
            task: null,
            noFollowUp: false,
            fetching: false,
            validationMessageList: [],
        }
    },
    [type.FIND_TASK_DETAIL_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            noFollowUp: false,
        }
    },
    [type.FIND_TASK_DETAIL_SUCCESS]: (state, action) => {
        const { task } = action.payload
        return {
            ...state,
            task,
            fetching: false,
        }
    },
    [type.FIND_TASK_DETAIL_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.TOGGLE_PROCESS_FLOW_VISIBILITY]: (state, action) => {
        return {
            ...state,
            processFlowVisible: !state.processFlowVisible,
        }
    },
    [type.UPDATE_VALIDATION_MESSAGE_LIST]: (state, action) => {
        const { validationMessageList } = action.payload
        return {
            ...state,
            validationMessageList,
        }
    },
    [type.CHANGE_TASK_STATUS_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.CHANGE_TASK_STATUS_SUCCESS]: (state, action) => {
        const { status } = action.payload
        return {
            ...state,
            fetching: false,
            task: {
                ...state.task,
                status,
            },
        }
    },
    [type.CHANGE_TASK_STATUS_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_DUE_DATE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.CHANGE_DUE_DATE_SUCCESS]: (state, action) => {
        const { due } = action.payload
        return {
            ...state,
            fetching: false,
            task: {
                ...state.task,
                due,
            },
        }
    },
    [type.CHANGE_DUE_DATE_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

    [type.CHANGE_PROCESS_TASK]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            task: {
                ...state.task,
                [name]: value,
            },
        }
    },
    [type.UPDATE_ASSIGNED_TO_USER_ID_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.UPDATE_ASSIGNED_TO_USER_ID_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.UPDATE_ASSIGNED_TO_USER_ID_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },


    [type.TRIGGER_EVENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.TRIGGER_EVENT_SUCCESS]: (state, action) => {
        const { task } = action.payload
        return {
            ...state,
            fetching: false,
            validationMessageList: [],
            task,
        }
    },
    [type.TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK]: (state, action) => {
        return {
            ...state,
            fetching: false,
            noFollowUp: true,
        }
    },
    [type.TRIGGER_EVENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CLAIM_TASK_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.CLAIM_TASK_SUCCESS]: (state, action) => {
        const { task } = action.payload
        return {
            ...state,
            fetching: false,
            task: {
                ...state.task,
                assignedToUserId: task.assignedToUserId,
            },
        }
    },
    [type.CLAIM_TASK_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.UN_CLAIM_TASK_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.UN_CLAIM_TASK_SUCCESS]: (state, action) => {
        const { task } = action.payload
        return {
            ...state,
            fetching: false,
            task: {
                ...state.task,
                assignedToUserId: task.assignedToUserId,
            },
        }
    },
    [type.UN_CLAIM_TASK_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/reducer.js